import { DateTime } from 'luxon';

import * as kind from './kind';

const parse = (value?: string | number | Date | null): DateTime | undefined => {
  if (!value) return;

  if (kind.isDate(value)) return DateTime.fromJSDate(value);
  if (kind.isString(value)) return DateTime.fromISO(value);
  if (kind.isNumber(value)) return DateTime.fromMillis(value);

  return value;
};

export const from = (value?: string | number | Date | null): Date | undefined => {
  return parse(value)?.toJSDate();
};

export const format = (value?: string | number | Date, fmt: string = 'F'): string | undefined => {
  return parse(value)?.toFormat(fmt);
}

export const utc = (value?: string | number | Date | null): Date | undefined => {
  return parse(value)?.toUTC().toJSDate();
}

export const local = (value?: string | number | Date | null): Date | undefined => {
  return parse(value)?.toLocal().toJSDate();
}

export const trim = (value?: string | number | Date | null): Date | undefined => {
  return parse(value)?.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toJSDate();
};
